/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangePublishDatePostPillRequest } from '../../models/change-publish-date-post-pill-request';

export interface ChangePublishDatePostPill$Params {
  id: number;
      body: ChangePublishDatePostPillRequest
}

export function changePublishDatePostPill(http: HttpClient, rootUrl: string, params: ChangePublishDatePostPill$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, changePublishDatePostPill.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

changePublishDatePostPill.PATH = '/api/editorial/post-pills/{id}/change-publish-date';
